export const LEARN_BASE_ROUTE = 'learn';
export const EXPLORE_BASE_ROUTE = 'explore';
export const TRIALS_BASE_ROUTE = 'try';
export const COLLECTIONS_BASE_ROUTE = 'collections';
export const CONFIRMATION_ROUTE = 'confirmation';
export const OFFER_REQUEST_BASE_ROUTE = 'offer-request';

// Parity with agentexchange-ui: these slugs are served by WordPressPageController.
// 'new' is the WordPress "What's New" page — keep even though the name is generic.
export const WORDPRESS_STATIC_PAGE_SLUGS = [
    'what-is-agentexchange',
    'ai-agent-directory',
    'ai-agent-marketplace',
    'ai-agent-marketplace-ecosystem-guide',
    'new',
    'whats-new',
    'df26-announcements',
    'df26-partner-pins',
] as const;

export type WordPressStaticPageSlug = (typeof WORDPRESS_STATIC_PAGE_SLUGS)[number];

// JP equivalents of WORDPRESS_STATIC_PAGE_SLUGS — path-based /jp/* routes on AgentExchange.
export const WORDPRESS_STATIC_PAGE_SLUGS_JP = ['jp/new-in-jp'] as const;

export type WordPressStaticPageSlugJP = (typeof WORDPRESS_STATIC_PAGE_SLUGS_JP)[number];

export const Routes = {
    // Content
    LISTING: 'appxListingDetail',
    SEARCH: 'appxSearchKeywordResults',
    EXPLORE: `${EXPLORE_BASE_ROUTE}/:bucket`,
    LEARN: `${LEARN_BASE_ROUTE}/:slug`,
    LEARN_HOME: LEARN_BASE_ROUTE,
    FAVORITE_LISTINGS: 'appxSavedListings',
    TRIALS: TRIALS_BASE_ROUTE,
    TRIALS_CONFIRMATION: `${TRIALS_BASE_ROUTE}/${CONFIRMATION_ROUTE}`,
    COLLECTION: `${COLLECTIONS_BASE_ROUTE}/:slug`,
    COLLECTIONS_HOME: COLLECTIONS_BASE_ROUTE,
    CONSULTING_HOME: 'consulting',
    OFFER_REQUEST: OFFER_REQUEST_BASE_ROUTE,
    SKILLS: 'skills',
    CLAUDEFORCE_BETA_ACCESS: 'sales-cloud-in-claude-beta-access',

    // WIP: Consultants and content listings are still in legacy
    CONTENT_LISTING: 'appxContentListingDetail',
    CONSULTANT_LISTING: 'appxConsultingListingDetail',

    // Authenticated
    SELECT_ORG: 'select-org',

    // Auth
    CALLBACK: 'callback',
    LOGIN: 'login',
    SIGN_UP: 'signup',

    // Misc
    HOME: '/',
    ERROR: 'error',
    NOT_FOUND: '*',

    // Japanese path-based routes
    JAPANESE_HOME: '/jp',
    JAPANESE_SEARCH: 'jp/appxSearchKeywordResults',
    JAPANESE_LISTING: 'jp/appxListingDetail',
    JAPANESE_EXPLORE: `jp/${EXPLORE_BASE_ROUTE}/:bucket`,
    JAPANESE_EXPLORE_BASE_ROUTE: `jp/${EXPLORE_BASE_ROUTE}`,
    JAPANESE_CONSULTING_HOME: 'jp/consulting',
    JAPANESE_LEARN: `jp/${LEARN_BASE_ROUTE}/:slug`,
    JAPANESE_LEARN_HOME: `jp/${LEARN_BASE_ROUTE}`,

    // Auth (JP path-based equivalents for AgentExchange)
    JAPANESE_LOGIN: 'jp/login',
    JAPANESE_SIGN_UP: 'jp/signup',
    JAPANESE_CALLBACK: 'jp/callback',
} as const;

export type Route = (typeof Routes)[keyof typeof Routes];
